import $ from 'jquery';

$(document).ready(function () {
  const $loadBtn = $('.cascade-nav');
  const $topBtn = $('.cascade-reset');
  const group = $loadBtn.data('cascade-group'); // "reviews"
  const $panes = $(`.cascade-group-${group}`);
  const totalPanes = $panes.length;

  // Make sure first pane is active
  $panes.first().addClass('is-active latest');

  // Load More button click
  $loadBtn.on('click', function () {
    let next = parseInt($(this).attr('data-next'), 10);

    if (next <= totalPanes) {
      const $nextPane = $(`#cascade-${next}.cascade-group-${group}`);
      if ($nextPane.length) {
        // Show next pane
        $nextPane.addClass('is-active latest');
        $panes.not($nextPane).removeClass('latest'); // update latest class
      }

      // If this was the last pane
      if (next === totalPanes) {
        $loadBtn.addClass('completed');  // hide load more
        $topBtn.removeClass('hidden');   // show top button
      }

      // Increment data-next
      $(this).attr('data-next', next + 1);
    }
  });

  // Top button click
  $topBtn.on('click', function () {
    // Remove all active panes except first
    $panes.not(':first').removeClass('is-active latest');

    // Reset Load More button
    $loadBtn.removeClass('completed').attr('data-next', 2);

    // Hide Top button again
    $topBtn.addClass('hidden');
  });
});
